import { Link } from "react-router-dom";
import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { BUSINESS } from "@/lib/site";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative bg-forest text-sand grain overflow-hidden">
            <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-10 pt-24 md:pt-32 pb-12">
                <p className="font-body text-sm uppercase tracking-[0.25em] text-sage/80 mb-6">
                    Ready when you are
                </p>
                <h2 className="font-heading font-extrabold tracking-tight text-5xl sm:text-6xl md:text-8xl leading-[0.92]">
                    Fresh bins. <br />
                    <span className="text-sky">Zero hassle.</span>
                </h2>

                <div className="mt-12 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
                    <Link
                        to="/book"
                        data-testid="footer-cta"
                        className="group inline-flex items-center gap-3 rounded-full bg-sand text-forest px-7 py-4 text-base font-semibold w-fit hover:bg-sky transition-colors duration-200"
                    >
                        Book your first clean
                        <ArrowUpRight className="group-hover:rotate-45 transition-transform duration-300" size={20} />
                    </Link>

                    <div className="space-y-3 text-sage">
                        <a href={BUSINESS.phoneHref} className="flex items-center gap-3 hover:text-sky transition-colors">
                            <Phone size={18} /> <span className="text-lg font-semibold text-sand">{BUSINESS.phone}</span>
                        </a>
                        <p className="flex items-center gap-3">
                            <MapPin size={18} /> {BUSINESS.area}
                        </p>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-sand/15 flex flex-col md:flex-row justify-between gap-4 text-sm text-sage/70">
                    <p>
                        © {new Date().getFullYear()} {BUSINESS.name} — Owned & operated by {BUSINESS.owner}.
                    </p>
                    <div className="flex gap-6">
                        <Link to="/" className="hover:text-sand transition-colors">Home</Link>
                        <Link to="/book" className="hover:text-sand transition-colors">Book</Link>
                        <Link to="/reviews" className="hover:text-sand transition-colors">Reviews</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
